import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../lib/api';
import { User, Mail, Calendar, Tag } from 'lucide-react';

export default function TenantAccount() {
  const { user } = useAuth();
  const [platformUser, setPlatformUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<{ platformUser: any }>('/auth/me')
      .then(data => setPlatformUser(data.platformUser))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const fields = [
    { icon: User, label: 'Naam', value: user?.full_name },
    { icon: Mail, label: 'E-mail', value: user?.email },
    { icon: Tag, label: 'Gewenste sitenaam', value: platformUser?.desired_site_name },
    { icon: Calendar, label: 'Aangemeld op', value: platformUser?.created_at ? new Date(platformUser.created_at).toLocaleDateString('nl-NL') : undefined },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Account</h1>
        <p className="text-sm text-gray-500 mt-1">Je accountgegevens</p>
      </div>

      <div className="card p-6">
        {loading ? (
          <div className="space-y-4">
            {[...Array(4)].map((_, i) => <div key={i} className="h-10 bg-gray-50 rounded animate-pulse" />)}
          </div>
        ) : (
          <div className="space-y-4">
            {fields.filter(f => f.value).map(f => (
              <div key={f.label} className="flex items-center gap-4 py-2">
                <div className="w-9 h-9 rounded-lg bg-gray-50 flex items-center justify-center flex-shrink-0">
                  <f.icon className="w-4 h-4 text-gray-400" />
                </div>
                <div>
                  <p className="text-xs text-gray-500">{f.label}</p>
                  <p className="text-sm font-medium text-gray-900">{f.value}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
